// ✅ File: src/components/OverBudgetModal.jsx (Final AI Budget Logic Ready)

import React, { useState } from 'react';

const OverBudgetModal = ({ open, onClose, overBudgetItems = [], onSubmit }) => {
  const [justification, setJustification] = useState('');
  const [reallocate, setReallocate] = useState(false);
  const [newCostCentre, setNewCostCentre] = useState('');

  const handleSubmit = () => {
    if (!justification.trim()) {
      alert('⛔ Please enter a justification.');
      return;
    }

    if (reallocate && !newCostCentre.trim()) {
      alert('⛔ Please specify a new cost centre if reallocating.');
      return;
    }

    onSubmit({ justification, reallocate, newCostCentre });

    // Reset form
    setJustification('');
    setReallocate(false);
    setNewCostCentre('');
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-lg w-full max-w-lg">
        <h2 className="text-xl font-semibold mb-4 text-red-700">⚠️ Over-Budget Shift Warning</h2>

        <div className="space-y-2 mb-4">
          {overBudgetItems.map((item, idx) => (
            <div key={idx} className="border p-2 rounded bg-red-50">
              <div className="font-semibold text-gray-800">{item.label}</div>
              <div className="text-sm text-gray-600">
                Cost: £{item.actualCost.toFixed(2)} | Budget: £{item.budget.toFixed(2)}
              </div>
            </div>
          ))}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Justification *</label>
          <textarea
            className="w-full border p-2 rounded"
            rows={3}
            value={justification}
            onChange={e => setJustification(e.target.value)}
            placeholder="Provide explanation for proceeding with over-budget shift"
          />
        </div>

        <div className="mb-4">
          <label className="inline-flex items-center text-sm text-gray-700">
            <input
              type="checkbox"
              checked={reallocate}
              onChange={e => setReallocate(e.target.checked)}
              className="mr-2"
            />
            Reallocate to a different cost centre
          </label>

          {reallocate && (
            <input
              type="text"
              placeholder="New cost centre ID or name"
              value={newCostCentre}
              onChange={e => setNewCostCentre(e.target.value)}
              className="mt-2 w-full border p-2 rounded"
            />
          )}
        </div>

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Submit Approval
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverBudgetModal;
